// Small building blocks for screens styled with theme/uh.css.
import React from 'react';

// Polaris icon component (from @shopify/polaris-icons) sized by uh.css:
// 20px by default, 16px with sm. Inherits colour from its parent.
export function Ic({ source: Source, sm = false, className = '' }) {
  return (
    <span className={`uh-icon${sm ? ' sm' : ''}${className ? ` ${className}` : ''}`} aria-hidden="true">
      <Source />
    </span>
  );
}

// tone: 'ful' | 'par' | 'hold' | 'can' | 'unf' | 'neu'. Neutral has no dot.
export function StatusPill({ tone, children }) {
  return (
    <span className={`uh-badge uh-s-${tone}`}>
      {tone !== 'neu' && <span className="d" />}
      {children}
    </span>
  );
}

export const EmDash = () => <span className="uh-faint">—</span>;
